import { render, staticRenderFns } from "./head-set.vue?vue&type=template&id=3baa1ef4&"
import script from "./head-set.vue?vue&type=script&lang=js&"
export * from "./head-set.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports